import { Badge } from '@/components';

export interface LogisticOperatorItem {
    id: string;
    logisticOperatorId: string;
    status: string;
    logisticOperator: {
        id: string;
        name: string;
    };
}

export interface LogisticOperatorsProps {
    logisticOperators?: LogisticOperatorItem[] | null;
}

export default function LogisticOperators({ logisticOperators }: LogisticOperatorsProps) {
    if (!logisticOperators || logisticOperators.length === 0) {
        return (
            <p className="mt-2 text-sm text-gray-500">
                Sin operadores asignados
            </p>
        );
    }

    return (
        <div className="mt-2 flex flex-wrap gap-2">
            {logisticOperators.map((operator) => (
                <Badge
                    key={operator.id}
                    value={operator.logisticOperator?.name ?? ''}
                    showBall={false}
                    backgroundColor="#F9FAFB"
                    textColor="#374151"
                />
            ))}
        </div>
    );
}
